import {memo} from 'react';

import type {SVGProps} from 'react';

export const PayinIcon = memo(function PayinIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      width={32}
      height={32}
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g fill="none" transform="rotate(180 16 16)">
        <path
          d="M30.6667 18.038V29.962C30.6667 30.7194 30.0527 31.3334 29.2954 31.3334H8.03808C7.28075 31.3334 6.66675 30.7194 6.66675 29.962V18.038C6.66675 17.2807 7.28075 16.6667 8.03808 16.6667H29.2954C30.0527 16.6667 30.6667 17.2807 30.6667 18.038Z"
          fill="var(--icon-fill-green)"
        />
        <path
          d="M24.0001 22.6667C24.7365 22.6667 25.3334 22.0697 25.3334 21.3333C25.3334 20.597 24.7365 20 24.0001 20C23.2637 20 22.6667 20.597 22.6667 21.3333C22.6667 22.0697 23.2637 22.6667 24.0001 22.6667Z"
          fill="var(--icon-stroke-green)"
        />
        <path
          d="M8.00008 22.6667C8.73646 22.6667 9.33341 22.0697 9.33341 21.3333C9.33341 20.597 8.73646 20 8.00008 20C7.2637 20 6.66675 20.597 6.66675 21.3333C6.66675 22.0697 7.2637 22.6667 8.00008 22.6667Z"
          fill="var(--icon-stroke-green)"
        />
        <path
          d="M19.4999 28.3333H5.66659C4.92992 28.3333 4.33325 27.7366 4.33325 27V15.6666C4.33325 14.93 4.92992 14.3333 5.66659 14.3333H7.33325"
          stroke="var(--icon-stroke-green)"
          strokeWidth={2}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M11.3333 14.3333H26.3333C27.0699 14.3333 27.6666 14.93 27.6666 15.6666V27C27.6666 27.7366 27.0699 28.3333 26.3333 28.3333H23.6453"
          stroke="var(--icon-stroke-green)"
          strokeWidth={2}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M16 25C17.6569 25 19 23.3584 19 21.3334C19 19.3083 17.6569 17.6667 16 17.6667C14.3431 17.6667 13 19.3083 13 21.3334C13 23.3584 14.3431 25 16 25Z"
          stroke="var(--icon-stroke-green)"
          strokeWidth={2}
          strokeLinejoin="round"
        />
        <path
          d="M16 5V11"
          stroke="var(--icon-stroke-green)"
          strokeWidth={2}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M18.6666 7.66667L15.9999 5L13.3333 7.66667"
          stroke="var(--icon-stroke-green)"
          strokeWidth={2}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
    </svg>
  );
});
